/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EventFinanceStatsStatsDto { 
    currency?: string;
    ticketsSold?: number;
    refundedTickets?: number;
    ticketsProcessed?: number;
    totalTicketPaid?: number;
    totalRefundedAmount?: number;
    totalStripeFee?: number;
    totalServiceFee?: number;
    refundRate?: number;
    avgPrice?: number;
    lastRefundAt?: string;
    commissionPercentage?: number;
    eventRevenue?: number;
    eventNetCash?: number;
    organizerEarning?: number;
    platformEarning?: number;
    platformRevenueBeforeFee?: number;
}

